// extracted by mini-css-extract-plugin
module.exports = {"texts":"SaleProjectDetailsLabels_texts__oaQiP","second-label":"SaleProjectDetailsLabels_second-label__0BGUk"};